/**
 * Appens navn og identitet – ett sted.
 *
 * Navnet brukes i manifest, sidetitler, login og sidemeny. Skal det byttes,
 * endre her; ingenting annet trenger å røres.
 *
 * «AInstein» = AI + Einstein, og «stein» fra Steinliveien der familien bor.
 */
export const BRAND = {
  /** Fullt navn, brukt i titler og manifest */
  name: "AInstein",
  /** Kort navn til hjemskjerm-ikonet (iOS/Android kutter lange navn) */
  shortName: "AInstein",
  /** Undertekst på login */
  tagline: "Familiens egen professor",
  /** Kort beskrivelse til manifest og metadata */
  description:
    "Privat familie-AI: dagens plan, kalender, garasje og chat – på vår egen PC",
  /**
   * Fargen operativsystemet maler statuslinja med.
   *
   * Var amber-600 (#d97706) – appens aksentfarge. Det ga en mørk oransje
   * stripe over en lys, varm side: en kant tvers over toppen som ikke fantes
   * i designet.
   *
   * Nå er den MÅLT, ikke valgt. Øverste pikselrad i appen er nesten helt jevn
   * på tvers – #fae8bc helt til venstre, #fae3b7 helt til høyre – og snittet
   * er dette. Da glir statuslinja inn i siden i stedet for å ligge oppå den.
   * Samme måling på «I dag», chat og garasjen.
   *
   * Innloggingssiden er mørk i toppen (#413a36, husbildet), så der treffer
   * den ikke. Den siden ser man én gang; appen ser man hele tiden.
   */
  themeColor: "#fae5b8",
  backgroundColor: "#faf6f0",
} as const;
